export enum AggregateFieldsApiEnum {
    SHARE = 'SHARE',
    REPLY = 'REPLY',
    QUOTE = 'QUOTE',
    LIKE = 'LIKE',
    VIEW = 'VIEW',
}
